import './App.css';
import './themes.css';
import Header from './components/header/Header';
import Home from './components/home/Home';
import About from './components/about/About';
import Skills from './components/skills/Skills';
import Services from './components/services/Services';
import Qualification from './components/qualification/Qualification';
import Contact from './components/contact/Contact';
import Footer from './components/footer/Footer';
import ScrollUp from './components/scrollup/ScrollUp';
import Project from './components/projects/Project';
import ThemeControls from './components/thememenu/ThemeControls';

function App() {
  return (
    <>
    <Header />
    <main className='main'>
      <Home />
      <About />
      <Skills />
      <Services />
      <Qualification />
      <Project />
      <Contact />
      <Footer />
      <ScrollUp />
      <ThemeControls />
    </main>
    </>
  );
}

export default App;
